import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getCryptoOrderList as getCryptoOrderListApi,
  getWalletActivities as getWalletActivitiesApi,
} from "../../helpers/fakebackend_helper";
import {
  createWalletByEntity,
  deleteVirtualWallet,
  getWalletsEntity,
  updateWalletInfo,
} from "../../helpers/dataBackend";
import { toast } from "react-toastify";
import { AppDispatch } from "slices";
import {
  fetchWalletsFailure,
  fetchWalletsSuccess,
  listWallets,
} from "./reducer";
import { setAuthorization } from "../../helpers/api_helper";

export const getWallets = () => async (dispatch: AppDispatch) => {
  dispatch(listWallets());
  try {
    const response = await getWalletsEntity();
    dispatch(fetchWalletsSuccess(response));
  } catch (error) {
    dispatch(fetchWalletsFailure(error));
  }
};

export const getWallet = createAsyncThunk("crypto/getWallet", async () => {
  try {
    const token = localStorage.getItem("authUser");
    setAuthorization(token);
    const response = await getWalletsEntity();
    return response;
  } catch (error) {
    return error;
  }
});

export const createWallet = createAsyncThunk(
  "crypto/createWallet",
  async (wallet: any) => {
    try {
      const response = await createWalletByEntity(wallet);
      toast.success("Wallet Created Successfully", { autoClose: 2000 });
      getWallets();
    } catch (error) {}
  }
);

export const updateWalletInfoFun = createAsyncThunk(
  "wallet/updateWallet",
  async (wallet: any) => {
    try {
      const { id, name } = wallet;
      const response = await updateWalletInfo(id, { name });
      // console.log(response);
      toast.update("Wallet Updated Successfully", { autoClose: 2000 });
    } catch (error) {
      toast.error("Contact Updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteWallet = createAsyncThunk(
  "wallet/deleteWallet",
  async (info: any) => {
    try {
      const { id, status_id } = info;
      let code;
      if (status_id === 1) {
        code = "IN";
      } else {
        code = "AC";
      }
      const response = await deleteVirtualWallet(id, { code: code }); // IN
      // console.log(response);
      toast.success("Status Wallet Changed Successfully", { autoClose: 2000 });
    } catch (error) {}
  }
);

// ----------------------------------------------------

export const getCryptoOrderList = createAsyncThunk(
  "crypto/getCryptoOrderList",
  async () => {
    try {
      const response = getCryptoOrderListApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getWalletActivities = createAsyncThunk(
  "crypto/getWalletActivities",
  async () => {
    try {
      const response = getWalletActivitiesApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);
